export default __webpack_public_path__ + "static/media/logo_vertical.5eb15821.svg";